import { IMeta } from './../auth/auth.interface'

export interface ICouponListResponse {
  id: string
  startDate: string
  endDate: string
  useDate?: string
  code: string
  description?: string
  value: number
  type: CouponTypeEnum
  userAllowedIds: string[]
  usageLimit: number
  isDeleted: boolean
  meta: IMeta
  ownerId: string
  orders: {
    orderNumber: string
  }[]
}

export interface ICouponData {
  id: string
  discountCode: string
  discount: string
  startDate: string
  expireDate: string
  isUsed: string
  useDate: string
  order: string
}

export enum CouponTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  VALUE = 'VALUE',
}
